module.exports = __webpack_public_path__ + "fonts/font.520bd8d.woff";